// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ei-z","breadcrumbItem":"fi-z"};